import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { pxToRem } from 'utils/styled'

export const SDirectiveUpgradeModal = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`

export const SAlignedPicture = styled.div`
  display: flex;
  justify-content: center;
`

export const SImg = styled.img`
  width: ${pxToRem(180)}rem;
  height: ${pxToRem(186)}rem;
  margin: 0 auto;
`

export const SReceiverImg = styled.img`
  width: ${pxToRem(232)}rem;
  height: ${pxToRem(240)}rem;
  margin: 0 auto;
`

export const SText = styled(Text)`
  text-align: center;
`

export const SLine = styled.hr`
  width: 90%;
  border: 0;
  border-top: 2px solid var(--c-blue100);
`

export const SButtonText = styled.span`
  display: flex;
  flex-direction: column;
  & > p {
    margin: 0;
    &:not(:last-child) {
      margin-bottom: 0.3rem;
    }
    &:last-child {
      font-size: smaller;
      font-weight: normal;
    }
  }
`
